import { request } from '@tencent/ppd-base-libs';

/**
 * 取消收藏分类红点
 */
export async function cancelTabReddot() {
  const res = await request.get('/app/promotion/we_coupon/confirm_user_subc.cgi');
  return res;
}
